'use client'

import { Chip } from '@/CommonComponents'
import ClicableItem from '@/Components/hoc/ClickableItem'
import { useState } from 'react'
import type { IColorSet } from '@/components/common/types'
import type { IAvailableIcons } from '@/components/common/Icon'
export interface IButtonOption {
  key: string
  label: string
}
interface IGetChipColors {
  colorSet?: IColorSet
  key: string
  isActive?: boolean
}

function getChipColors({ colorSet, key, isActive }: IGetChipColors) {
  if (colorSet && colorSet[key]) {
    return {
      color: colorSet[key].color,
      borderColor: colorSet[key].backgroundColor,
      backgroundColor: isActive ? colorSet[key].backgroundColor : 'transparent',
    }
  }
  return {
    color: isActive ? 'background.default' : 'primary.main',
    borderColor: 'primary.main',
    backgroundColor: isActive ? 'primary.main' : 'transparent',
  }
}
interface IToggleButtonProps {
  options: IButtonOption[]
  onSelect: (key: string | null) => void
  iconSet?: Record<string, IAvailableIcons>
  colorSet?: IColorSet
}
export default function ToggleButtonGroup({ options, colorSet, iconSet, onSelect }: IToggleButtonProps) {
  const [activeKey, setActiveKey] = useState<string | null>(null)

  const onClickButton = (key: string) => {
    if (activeKey === key) {
      setActiveKey(null)
      onSelect(null)
    } else {
      setActiveKey(key)
      onSelect(key)
    }
  }

  return (
    <>
      {options.map(({ key, label }) => (
        <ClicableItem
          key={key}
          onClick={() => {
            onClickButton(key)
          }}
        >
          <Chip
            sx={getChipColors({ colorSet, key, isActive: activeKey === key })}
            label={label}
            icon={iconSet?.[key]}
            variant={activeKey === key ? 'filled' : 'outlined'}
            size="small"
          />
        </ClicableItem>
      ))}
    </>
  )
}
